import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import DocumentTable from '../components/documentTable'
import Header from '../components/header'
import AppLayout from '../components/AppLayout'
import { getBusinessDocuments } from '../logic/business/action'

const DocumentScreen = () => {
    const dispatch = useDispatch();
    const selector = useSelector(state=>state.auth);
    useEffect(() => {
        getBusinessDocuments(dispatch, selector?.user?.business_id);
    }, [selector?.user?.business_id]);
  return (
  <AppLayout>
  <div className="w-full h-full flex flex-col items-start gap-4 p-4">
    {/* <div className="w-full h-full"> */}
   <Header/> 
   <div className="flex justify-between w-full">
          <h1 className="font-bold text-2xl">Documents</h1>
          <Link to={"/admin/business/add"}>
            <button className="w-12 h-12 rounded-full">+</button>
          </Link>
        </div>
   <DocumentTable setEditMode={(data) => {
            //   setStateForm({...data})
            //   setEditMode((prev) => !prev)
            }
          } />
   </div>  
    </AppLayout>
  )
}

export default DocumentScreen